// extracted by mini-css-extract-plugin
export default {"content":"dialog_content__4F+H5","close_btn":"dialog_close_btn__EPUtb","footer":"dialog_footer__qs7+9","location":"dialog_location__S7aN5","link":"dialog_link__1PqIo"};